import { Component, Input } from '@angular/core';
import { BusinessHour } from '../interface/business-hour.interface';

@Component({
  selector: 'app-business-hour-preview',
  templateUrl: '../templates/template1/views/business-hour-preview.component.html',
  styleUrls: ['../templates/template1/themes/default/less/business-hour-preview.component.less']
})
export class BusinessHourPreviewComponent {

  @Input()
  businessHours: BusinessHour[];

  constructor() { }

}



// WEBPACK FOOTER //
// ./src/app/customerservice/components/business-hour-preview.component.ts